<template>
    <header class="masthead pt-5 bg-dark">
        <Event v-if="!video_start" @video="showVideo" />
        <Streaming 
            v-else-if="isLoggedIn"
            :urls="streaming_url" 
            :room="streaming_room" 
            :data="{'event_id': this.event.key_id, 'name':'En Vivo'}"
            @closed="video_start=false"
        />
    </header>
</template>

<script>
import Vue from 'vue'
import Event from '@/components/Event/Event.vue'
import Streaming from '@/components/Streaming/Streaming.vue'

export default Vue.extend({
    name: "Header",
    data() {
        return {
            video_start : false,
            streaming_url:[],
            streaming_room: null
        }
    },
    components: {
        Event,
        Streaming
    },
    computed: {
        event() {return this.$store.getters.event},
        isLoggedIn : function() {return this.$store.getters.isLoggedIn},
    },
    methods: {
        showVideo( data ) {
            if(data) {
                this.streaming_url = data.urls
                this.streaming_room = { id: data.id, name: data.name }
                this.video_start = true
            }
        },
    },
})
</script>

<style lang="scss" scoped>
@import '../../styles/app';

.masthead {
  padding-bottom: 1rem;
}
</style>